const KeenSlider = window.KeenSlider

const { setInitialised, useA11y, useArrows } = window.BAO.Carousel.plugins

class CartCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
    this.updateSlideAccessibility()
  }

  setupListeners () {
    if (!this.carousel) return

    this.listeners.add(this.carousel.container, 'slide.change', () => {
      this.updateSlideAccessibility()
    })
  }

  updateSlideAccessibility () {
    if (!this.els.slide?.exists || !this.carousel?.track?.details) return

    const slides = this.els.slide.elements
    const slideDetails = this.carousel.track.details.slides || []

    slides.forEach((slide, index) => {
      const isVisible = (slideDetails[index]?.portion || 0) > 0

      slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true')

      const focusableSelector =
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      const focusableElements = slide.querySelectorAll(focusableSelector)

      focusableElements.forEach((el) => {
        if (isVisible) {
          el.removeAttribute('tabindex')
        } else {
          el.setAttribute('tabindex', '-1')
        }
      })
    })
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.9,
          spacing: 10,
        },
      },
      [
        setInitialised(),
        useA11y(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('cart-carousel')) {
  customElements.define('cart-carousel', CartCarousel)
}
